import React, { useEffect, useState } from 'react';
import { Tree } from 'antd';
import { getApps } from '@/services/source';
import PropertyName from './components/PropertyName';
import styles from './index.module.less';
interface Props {
  title: string;
}

const formatData: any = (list: any) => {
  return list.map((item: any) => {
    return {
      title: item.name,
      id: item.code, // 数据操作使用 key, 新建结点只有key没有id
      key: item.code,
      count: item.linkCnt,
    };
  });
};

const AppSetting: React.FC<Props> = (props: Props) => {
  const { title } = props;
  const [settingDataTree, setSettingDataTree] = useState<any[]>([]);

  const fetchAppOptions = async () => {
    const res = await getApps('app', true);
    if (res?.success) {
      setSettingDataTree(formatData(res?.data?.details || []));
    }
  };

  useEffect(() => {
    fetchAppOptions();
  }, []);

  const titleRender = (data: any) => {
    return <PropertyName property={data}></PropertyName>;
  };

  return (
    <div className={styles.patternWrap}>
      <div className={styles.header}>
        <span className={styles.title}>{title}</span>
      </div>
      <div className={styles.body}>
        <Tree
          blockNode={true}
          treeData={settingDataTree}
          draggable={false}
          titleRender={titleRender}
        />
      </div>
    </div>
  );
};

export default React.memo(AppSetting);
